"use client"

import { sendGTMEvent } from "@next/third-parties/google"
import { useEffect } from "react"

interface Props {
    slug?: string | undefined
    amount?: number | undefined
}

export function SuccessfulPurchase({ slug, amount }: Props) {
    useEffect(() => {
        sendGTMEvent({
            event: "successful_purchase",
            slug,
            amount,
        })
    }, [])

    return <></>
}
